<script lang="ts">import ItemList from '../../../../shared/Cart/ItemList/ItemList.svelte';
import Status from '../../../../shared/Cart/Status/Status.svelte';
import { GLOBAL_NAV_MOBILE_CART_CONTENT_ID } from '../../../../../../js-v2/constants';
const { id = '', statusZero = '', statusOne = '', statusMany = '', primaryNavItems = [], secondaryNavItems = [], slideInFrom = 'top', } = $props();
</script>

<div id={GLOBAL_NAV_MOBILE_CART_CONTENT_ID} data-entry-id={id} class="Cart">
  <Status {statusZero} {statusOne} {statusMany} {slideInFrom} />
  {#if primaryNavItems}
    <ItemList navItems={primaryNavItems} cartPrimary={true} listStartingIndex={1} {slideInFrom} />
  {/if}
  {#if secondaryNavItems}
    <ItemList navItems={secondaryNavItems} listStartingIndex={1 + primaryNavItems?.length || 0} {slideInFrom} />
  {/if}
</div>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.Cart {
  --color-theme: #006aff;
  --color-theme-focus: #05c;
  position: relative;
  box-sizing: border-box;
}
.Cart :global(.ItemList.slide-in-from-left li) {
  opacity: 0;
  transform: translateX(-4px) translateY(0);
  animation: fade-in-slide-from-left 300ms ease-in forwards;
  animation-delay: calc(150ms + var(--item-list-item-number) * 20ms);
}
.Cart :global(.Status.slide-in-from-left div) {
  opacity: 0;
  transform: translateX(-4px) translateY(0);
  animation: fade-in-slide-from-left 300ms ease-in forwards;
  animation-delay: calc(150ms + var(--item-number) * 20ms);
}</style>
